export const GOOGLE_MAPS_API_KEY = "AIzaSyBov1Wd7NcaoQmrLU5xnnEFQ2ZBiokzurk";
export const GOOGLE_MAPS_LIBRARIES = ["places", "geometry"];

export const statusColors = {
  1: "#D5FFD3", // Activa
  2: "#D3F0FF", // Pendiente Iniciar
  3: "#FFF6D3", // Pausada
  4: "#E0E0E0", // Finalizada
  5: "#FFD6D6", // Eliminada
};

export const chartColors = [
  "#4CAF50", // Verde
  "#90CAF9", // Azul claro
  "#80CBC4", // Verde agua
  "#FFF176", // Amarillo
  "#EF9A9A", // Rojo claro
  "#CE93D8", // Morado
  "#FFB74D", // Naranja
  "#A1887F", // Marrón
  "#64B5F6", // Azul medio
  "#E57373", // Rojo medio
];

export const CALIFICATIONS = [
  { id: 1, title: "Terrible" },
  { id: 2, title: "Malo" },
  { id: 3, title: "Bien" },
  { id: 4, title: "Bueno" },
  { id: 5, title: "Excelente" },
]

